<template>
    <div class="totalizer" :class="savingAmount || savingAmount == 0 ? 'white' : 'grey lighten-3'">
        <h2 class="text-center mb-4">{{ title }}</h2>

        <div class="description">
            <label>{{ $t('module-budget.main-budget.totalizer-component.description.label1') }}</label>
            <p data-cy="total-final-net-operations">{{ totalNetOperations | currency }}</p>

            <label>{{ $t('module-budget.main-budget.totalizer-component.description.label2') }}</label>
            <p data-cy="total-final-net-parts">{{ totalNetParts | currency }}</p>

            <v-divider></v-divider>

            <label>{{ $t('module-budget.main-budget.totalizer-component.description.label3') }}</label>
            <p data-cy="total-final-withoutVAT">{{ computedTotalWithoutVAT | currency }}</p>

            <label>{{ $t('module-budget.main-budget.totalizer-component.description.label4', {vat: VAT}) }}</label>
            <p data-cy="total-VAT">{{ computedVAT | currency }}</p>

            <v-divider></v-divider>
        </div>

        <div class="total">
            <div class="cost-info-card" v-if="modalCost == 1">
                <v-card
                    elevation="2"
                >
                    <div class="card-style">
                        <div class="mb-4">
                            <h3>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.labor-hour') }}</h3>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.cost-price') }}
                                <span>{{ pcOperation | currency }} </span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.sell-price') }}
                                <span>{{ pvOperation  | currency }} </span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.margin') }}
                                <span>{{ margeOperation  | currency }} </span></p>
                            <p><span>({{ percOperation.toFixed(0) }}%)</span></p>
                        </div>
                        <div class="mb-4">
                            <h3>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.part') }}</h3>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.cost-price') }}
                                <span>{{ cmPart  | currency }}</span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.sell-price') }}
                                <span>{{ pvPart  | currency }}</span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.margin') }}
                                <span>{{ marginPart | currency }}</span></p>
                            <p><span>({{ percPart.toFixed(0) }}%)</span></p>
                        </div>
                        <div>
                            <h3>
                                {{
                                    $t('module-budget.main-budget.totalizer-component.cost-info-card.total-budget')
                                }}</h3>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.cost-price') }}
                                <span>{{ co | currency }}</span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.sell-price') }}
                                <span>{{ pvp | currency }}</span></p>
                            <p>{{ $t('module-budget.main-budget.totalizer-component.cost-info-card.margin') }}
                                <span>{{ margin | currency }}</span></p>
                            <p><span>({{ percentual.toFixed(0) }}%)</span></p>
                            <p>
                                <small>
                                    {{ $t('module-budget.main-budget.totalizer-component.cost-info-card.subtitle') }}
                                </small>
                            </p>
                        </div>
                    </div>
                </v-card>
            </div>


            <label>{{ totalTitle }}</label>

            <span class="info-svg" v-if="modalCost == 1" @click="onClickInformation" @mouseover="mouseOverInformation"
                  @mouseleave="mouseDownInformation">
                <img src="/images/_SVGs/information.svg" onload="SVGInject(this)" width="20" height="20"
                     style="margin-left:4px;"/>
            </span>

            <p :class="{ 'blue--text': savingAmount }" data-cy="total-final-OEprice">{{ computedTotal | currency }}</p>
            <span v-if="savingAmount"
                  :class="isNegative ? 'red--text font-weight-black' : 'green--text'">{{
                    isNegative ? '' : $t('module-budget.main-budget.totalizer-component.cost-info-card.saves')
                }}  {{ savingAmount | currency }}</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        type: {
            type: String,
            required: true,
            validator: function (type) {
                return ['oe', 'iam'].indexOf(type) >= 0;
            }
        },
        title: {
            type: String,
            required: true
        },
        totalTitle: {
            type: String,
            required: true
        },
        totalNetOperations: {
            type: [String, Number],
            required: true,
            default: 0
        },
        totalNetParts: {
            type: [String, Number],
            required: true,
            default: 0
        },
        savingAmount: {
            type: [String, Number]
        },
        modalCost: {
            type: [String, Number]
        },
        laborCost: {
            type: [String, Number]
        }
    },
    data() {
        return {
            VAT: 23,
            isNegative: false,
            pcOperation: 0,
            pvOperation: 0,
            margeOperation: 0,
            percOperation: 0,
            cmPart: 0,
            pvPart: 0,
            marginPart: 0,
            percPart: 0,
            co: 0,
            pvp: 0,
            margin: 0,
            percentual: 0,
            infoCounter: false,
        };
    },
    computed: {
        computedTotalWithoutVAT() {
            return this.totalNetOperations + this.totalNetParts
        },
        computedVAT() {
            return +(this.computedTotalWithoutVAT * (this.VAT / 100));
        },
        computedTotal() {
            return this.computedTotalWithoutVAT + this.computedVAT;
        },
        computedBudgetSummary() {
            return this.$store.getters['budget/getBudgetSummary'];
        }
    },

    watch: {
        savingAmount: {
            handler: function (newValue, oldValue) {
                this.isNegative = Math.sign(newValue) === -1;
            }
        },
    },

    methods: {
        calcIAM() {


            const cloneBudgetSummary = _.cloneDeep(this.computedBudgetSummary)
            //Calc IAM COST
            /*
                CALC OPERATIONS
                P.C --> Custo de MO x Total de horas
                P.V --> Sub-Total Líquido x Total de horas x Desconto geral
                Margem --> € = P.V - P.C
                (%) = (P.C / P.V) - 1
            */

            let totalHours = cloneBudgetSummary.operations.totals.totalDuration ? cloneBudgetSummary.operations.totals.totalDuration.hours : 0
            let totalMinutes = cloneBudgetSummary.operations.totals.totalDuration ? cloneBudgetSummary.operations.totals.totalDuration.minutes : 0

            const pcOperation = +this.laborCost * +(+totalHours + +totalMinutes / 60);
            const pvOperation = +cloneBudgetSummary.operations.totals.totalWithDiscount
            const margeOperation = +pvOperation - +pcOperation
            const percOperation = (+margeOperation / +pvOperation) * 100
            //End Calc Operations

            /*
                Calc Parts

                C.M (Custo da mercadoria)
                V.M (Venda da mercadoria)
                Margem (em €) e (%)

                C.M --> Price (Apenas mapear campo) -> Este valor é retornado no método que obtem equivalencia IAM, e deverá passar a ser retornado para o FE na resposta das peças IAM.
                P.V --> PurchasePrice (Apenas mapear campo) -> Este valor é retornado no método que obtem equivalencia IAM, e deverá passar a ser retornado para o FE na resposta das peças IAM. Ou seja, na resposta terá que ser adicionado um novo campo com os dois preços.
                Margem --> € = V.M - C.M
                (%) = (C.M / V.M) - 1
            */

            const filter = cloneBudgetSummary.parts.values.filter(el => el.isIam == true || String(el.itemMpId).includes('-111'));
            let getGlobalDiscountParts = cloneBudgetSummary.parts.totals.globalDiscount ? cloneBudgetSummary.parts.totals.globalDiscount : 0;
            getGlobalDiscountParts = (100 - getGlobalDiscountParts);
            getGlobalDiscountParts = getGlobalDiscountParts / 100;

            const cmPart = filter.length > 0 ? filter.map((part) => (part.costPrice ? +part.costPrice : 0) * +part.quantity).reduce((total, part) => total += +part) : 0
            const pvPart = filter.length > 0 ? filter.map((part) => +part.totalWithoutVAT).reduce((total, part) => total += +part) : 0;
            const pvPartWithTotalDiscount = pvPart * getGlobalDiscountParts;
            const marginPart = +pvPartWithTotalDiscount - +cmPart
            const percPart = marginPart == 0 ? 0 : (+marginPart / +pvPartWithTotalDiscount) * 100

            ///////////
            const co = +pcOperation + +cmPart
            const pvp = +pvPart + +pvOperation
            const margin = pvp - co
            const percentual = margin == 0 ? 0 : (+margin / +pvp) * 100

            this.pcOperation = pcOperation
            this.pvOperation = pvOperation
            this.margeOperation = margeOperation
            this.percOperation = percOperation
            this.cmPart = cmPart
            this.pvPart = pvPartWithTotalDiscount
            this.marginPart = marginPart
            this.percPart = percPart
            this.co = co
            this.pvp = pvp
            this.margin = margin
            this.percentual = percentual

            const payload = {
                "moCostPrice": pcOperation,
                "moSellPrice": pvOperation,
                "moMargin": margeOperation,
                "moMarginPercentage": percOperation,
                "partCostPrice": cmPart,
                "partSellPrice": pvPart,
                "partMargin": marginPart,
                "partMarginPercentage": percPart,
                "iamOperationCost": co,
                "iampvp": pvp,
                "iamMargin": margin,
                "iamMarginPercentage": percentual
            }

            this.$store.commit('budget/setCalcCost', payload);

        },
        commitToStore() {
            /**
             * save totals' information in the store
             */
            this.calcIAM()
            const finalTotals = {
                totalOperations: this.$options.filters.currency(+this.totalNetOperations, true, false),
                totalParts: this.$options.filters.currency(+this.totalNetParts, true, false),
                totalWithoutVAT: this.$options.filters.currency(+this.computedTotalWithoutVAT, true, false),
                vat: this.$options.filters.currency(+this.computedVAT, true, false),
                total: this.$options.filters.currency(+this.computedTotal, true, false),
            };

            this.$store.commit('budget/setFinalTotalsToBudgetSumamry', {finalTotals, type: this.type});
        },
        mouseOverInformation() {
            $(".cost-info-card").addClass('action');
        },
        mouseDownInformation() {
            $(".cost-info-card").removeClass('action');
        },
        onClickInformation() {
            if (this.infoCounter) {
                this.mouseDownInformation();
                this.infoCounter = !this.infoCounter;
            } else {
                this.mouseOverInformation();
                this.infoCounter = !this.infoCounter;
            }
        }
    },
    mounted() {
        this.VAT = this.$store.getters['auth/getState'].vat;
        this.commitToStore();
    },
    updated() {
        this.commitToStore();
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.totalizer {
    position: relative;
    width: 100%;
    max-width: 310px;
    padding: 25px 40px 30px;
    border-radius: 16px;
    text-align: right;

    @media(max-width: 430px) {
        max-width: 100%;
    }
}

.description {
    margin-bottom: 20px;

    label {
        font-size: 12px;
        line-height: 1.1em;
        font-weight: 400;
        letter-spacing: 0.24px;
        color: $grey;
        margin-bottom: 5px;
    }

    p {
        margin: 0 0 20px;
        font-size: 14px;
        line-height: 1.1em;
        font-weight: 400;
        letter-spacing: 0.28px;
        color: $grey-dark;
    }
}

.total {

    label {
        font-size: 16px;
        line-height: 1.1em;
        font-weight: 500;
        color: $grey;
        margin-bottom: 5px;
    }

    p {
        margin: 0;
        padding: 4px 0;
        font-size: 24px;
        line-height: 1.1em;
        font-weight: 400;
    }

    span {
        font-size: 14px;
    }
}

.info-svg {
    ::v-deep svg {
        path {
            fill: var(--v-primary-base);
        }
    }
}

.cost-info-card {
    position: absolute;
    top: -95px;
    left: 35px;

    display: none;

    &::after {
        content: ' ';
        position: absolute;
        bottom: -20px;
        right: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 35px 30px 0;
        border-color: transparent #ffffff transparent transparent;
        line-height: 0px;

        @media(max-width: 426px) {
            content: initial;
        }
    }

    &::before {
        content: " ";
        position: absolute;
        bottom: -23px;
        right: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 36px 31px 0;
        border-color: transparent #bbb8b882 transparent transparent;
        line-height: 0px;

        @media(max-width: 426px) {
            content: initial;
        }
    }

    @media (max-width: 550px) {
        position: absolute;
        top: -200px;
        left: initial;
        right: 10%;
        width: 250px;
    }

    &.action {
        display: block;
    }

    ::v-deep .v-card.v-sheet {
        padding: 10px;
        border-radius: 15px;
        @media (max-width: 550px) {
            padding: 0;
        }
    }

    .card-style {
        padding: 10px;
        background: var(--v-primary-base);
        color: #fff;
        width: 205px;
        @media (max-width: 550px) {
            padding: 15px;
            width: 100%;
        }

        h3 {
            color: #fff;
            font-size: 16px;
            font-weight: 500;
        }

        p, span {
            font-size: 12px;
        }

        @media (max-width: 550px) {
            span {
                display: block;
            }
        }
    }

    @media(min-width: 1439px) and (max-width: 1919px) {
        left: -5px;
    }

    @media(min-width: 769px) and (max-width: 1025px) {
        top: -49px;
        left: -42px;
    }

    @media(min-width: 426px) and (max-width: 780px) {
        top: -20px;
        left: -95px;
    }
}
</style>
